import React from 'react'

export default function Eleven() {
return (
<>
    <section className="faq-section section">
        <div className="container">
            <div className="faq-sec">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-10 wow fadeInUp text-center" data-wow-delay="0.2s">
                        <div className="section-header text-center">
                            <h2 className="mb-2">Frequently Asked Questions</h2>
                            <p className="sub-title">Cornleth, a hotel & tour booking operator specializing in dream destinations, offers a
                                variety of benefits for travelers.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 mx-auto">
                        <div className="accordion accordion-flush" id="accordionFaq">
                            <div className="accordion-item show wow fadeInUp mb-3 pb-3" data-wow-delay="0.2s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#faq-collapseOne" aria-expanded="false"
                                        aria-controls="faq-collapseOne">
                                        How does the Cornleth B2B system work?
                                    </button>
                                </h2>
                                <div id="faq-collapseOne" className="accordion-collapse show collapse"
                                    data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p className="mb-0">Cornleth’s B2B system provides travel agencies with an advanced dashboard. Agencies can search for hotels and tours, retrieve data through an API, and make bookings instantly. Additionally, the system offers reporting capabilities, enabling agencies to efficiently manage and analyze their operations. </p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp mb-3 pb-3" data-wow-delay="0.4s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#faq-collapsetwo" aria-expanded="false"
                                        aria-controls="faq-collapsetwo">
                                        How does the B2C system work for end-users?
                                    </button>
                                </h2>
                                <div id="faq-collapsetwo" className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>In the B2C system, bookings made by agencies are made available to end-users. These users can then directly make hotel and tour reservations through the platform, providing a seamless and fast booking experience for individual customers.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp mb-3 pb-3" data-wow-delay="0.6s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#faq-collapsthree" aria-expanded="false"
                                        aria-controls="faq-collapsthree">
                                        What reporting features does Cornleth offer?
                                    </button>
                                </h2>
                                <div id="faq-collapsthree" className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Cornleth’s reporting features offer a wide range of analysis and tracking options for B2B users. These reports allow agencies to monitor sales performance, identify trends, and make data-driven decisions to improve their business operations.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item wow fadeInUp mb-3 pb-3" data-wow-delay="0.6s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#faq-collaps1" aria-expanded="false"
                                        aria-controls="faq-collaps1">
                                        Does Cornleth support API integration for travel agencies?
                                    </button>
                                </h2>
                                <div id="faq-collaps1" className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Yes! Cornleth provides API access that allows travel agencies to seamlessly integrate hotel and tour data into their own systems. This feature ensures real-time data retrieval, making the booking process faster and more efficient.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item wow fadeInUp mb-3 pb-3" data-wow-delay="0.6s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#faq-collaps2" aria-expanded="false"
                                        aria-controls="faq-collaps2">
                                        What makes Cornleth different from other travel platforms?
                                    </button>
                                </h2>
                                <div id="faq-collaps2" className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Cornleth stands out with its all-in-one CRM system designed for both B2B and B2C users. Our platform not only simplifies hotel and tour bookings but also provides powerful reporting tools, a user-friendly interface, and seamless API integration—making it the ultimate solution for travel professionals.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="accordion-item wow fadeInUp mb-3 pb-3" data-wow-delay="0.6s">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#faq-collaps3" aria-expanded="false"
                                        aria-controls="faq-collaps3">
                                        What is Cornleth’s mission?
                                    </button>
                                </h2>
                                <div id="faq-collaps3" className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFaq">
                                    <div className="accordion-body">
                                        <p>Cornleth’s mission is to make travel more accessible, enjoyable, and hassle-free for everyone. We are committed to providing a flexible and efficient platform that meets the needs of both travel agencies and individual travelers.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</>
)
}
